import api from "@/config/api";

const path = "public/formular/employee/accidentreport"

export default {

  get: (token) => {
    return api.get(`${path}/${token}`)
  },
  post: (accidentreport, token, abschliessen = false) => {
    return api.post(path, accidentreport, { params: { token, abschliessen } })
  }
}
